import React, {lazy, Suspense, useEffect, useState} from 'react';
import clsx from 'clsx';

import Loader from '../../../modules/auth/components/ui/loader';
import {TrendArticlesList} from '../../components/trend-articles-list';
import {TrendComments} from '../../components/trend-comments';
import {TrendSidebar} from '../../components/trend-sidebar';
import useFetch from '../../hooks/use-fetch';
import {getTimeStamp} from '../../utils/date';
import {customFetch} from '../../utils/fetch';
import '../../i18n/config';

import styles from './trend.module.css';

const TrendBody = lazy(() => import('../../components/trend-body'));
const TrendBodycustom = lazy(() => import('../../components/trend-body-custom'));
const TrendPreview = lazy(() => import('../../components/trend-preview'));

const TrendPage = () => {
  const [isLoadingMoreTrends, setLoadingMoreTrends] = useState(false);
  const [articles, setArticles] = useState([]);
  const slug = window.location.pathname.replace('/trends/', '').replace('/', '');
  const trendData = useFetch({
    url: `trends?sectionId=${window.Site?.targeting.sectionId}&slug=${slug}`,
    initialData: null
  });
  const containerClassNames = clsx({
    [styles.container]: true,
    [styles.customContainer]: !trendData.isLoading && trendData.data?.[0].isCustom
  });

  useEffect(async () => {
    if (trendData.data && !trendData.isLoading) {
      try {
        const data = await customFetch({url: `trends/${trendData.data?.[0].id}/articles?limit=10`});

        setArticles(data);
      } catch (e) {
        console.warn(e);
      }
    }
  }, [trendData]);

  const onGetMoreArticles = async () => {
    const lastArticle = articles[articles.length - 1];

    setLoadingMoreTrends(true);

    try {
      const data = await customFetch({
        url: `trends/${trendData.data?.[0].id}/articles?limit=10&after=${getTimeStamp(lastArticle.publishedAt)}`
      });

      setArticles(prevState => [...prevState, ...data]);
    } catch (e) {
      console.warn(e);
    } finally {
      setLoadingMoreTrends(false);
    }
  };

  const isDesktop = window.Site?.targeting.platform === 'desktop';

  return (
    <>
      <Suspense fallback={<Loader />}>
        {!trendData.isLoading && (trendData.data?.[0]?.isCustom
          ? <TrendBodycustom trend={trendData.data} />
          : <TrendBody trend={trendData.data} />
        )}
      </Suspense>
      <div className={containerClassNames}>
        <div className={styles.contentWrapper}>
          <Suspense fallback={<Loader />}>
            {!trendData.isLoading && (trendData.data?.[0].isCustom
              ? null
              : <TrendPreview trend={trendData.data} />
            )}
          </Suspense>
          <TrendArticlesList
            isLoading={isLoadingMoreTrends}
            articles={articles}
            getMoreArticles={onGetMoreArticles}
            withHeader={!trendData.isLoading && trendData.data?.[0].isCustom}
            isCustom={trendData.data?.[0].isCustom}
          />
          <TrendComments />
        </div>
        {isDesktop && <TrendSidebar />}
      </div>
    </>
  );
};

export {TrendPage};
